module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("sitepage_photosets", [["div",{"class":"content-block pad-lr pad-tb","id":"last_added_photosets","itemscope":"","itemtype":"http://schema.org/ImageGallery"}],["div",{"class":"clear"}],["div",{"id":"newsletter-container"}],["div",{"class":"join-banner-wrpper"}]]);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-dynamic-injection!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-template-loader?interpolate!./templates/sitepage/photosets.tpl
// module id = 1240
// module chunks = 4